<template>
  <div class="main frame-road">
    <div class="frame-bg">
      <img class="frame-img" src="/assets/images/frame-road.webp" alt />
    </div>
    <div class="frame-overlay"></div>
    <!-- <leaves></leaves> -->
    <div class="frame-content container-fluid fade-in">
      <div class="frame-text mt-5" :data-aos="animation">
        <p class="text-center">
          ValhallaVerse is a Norse <br />
          mythology-themed ecosystem, <br />
          powered by Avalanche Network, <br />
          where players compete <br />
          in PvP arenas and go on challenging <br />
          adventures that are paired with <br />
          Play-and-Earn mechanics.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Leaves from "@/components/Leaves.vue";

export default {
  mounted() {
    setInterval(() => {
      if (!this.hoverDoor) {
        this.hoverDoor = true;
        setTimeout(() => (this.hoverDoor = false), 500);
      }
    }, 5000);
  },
  components: {
    Leaves,
  },
};
</script>

<style lang="scss" scoped>
.frame-road {
  position: relative;
  overflow: hidden;
  .frame-bg {
    position: relative;
    height: 100%;
    width: 100%;
    min-height: 100vh;
    overflow: hidden;
    .frame-img {
      object-fit: cover;
      width: 100%;
      height: 100%;
      min-height: 100vh;
      transition: transform 1s ease-in-out;
    }
  }
  .frame-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
      0deg,
      rgba(0, 0, 0, 1) 0%,
      rgba(0, 0, 0, 0) 2.5%,
      rgba(0, 0, 0, 0) 97.5%,
      rgba(0, 0, 0, 1) 100%
    );
  }
  .frame-content {
    position: absolute;
    z-index: 1;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0) 33%);
    .frame-text {
      text-shadow: 0 0 5px rgb(0 0 0);
    }
  }
}
</style>
